@if (registration) {
  <div class="card mb-3 bg-light-subtle">
    <div class="row g-0">
      <div class="col-md-3 d-none d-md-flex justify-content-center">
        <div class="country-card-icon row align-content-center" [ngbTooltip]="jurisdictionCode" placement="end">
          <i class="mdi mdi-earth" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card-body">
          <h3 class="card-title">
            {{ label }}
            @if (registration.status === autoRegisterStatuses.REGISTERED && registration.vat_tax_id) {
              <span class="badge bg-primary-subtle text-primary">
                <span class="fw-semibold">#TAX_ID: {{ registration.vat_tax_id }}</span>
              </span>
            }
          </h3>
          <p class="m-0">
            <small class="text-muted">
              <i aria-hidden="true" class="mdi mdi-map-marker"></i>
              Jurisdiction:
            </small>
            <small>{{ jurisdictionCode }}</small>
          </p>
          @if (registration.payment_schedule) {
            <p class="m-0">
              <small class="text-muted">
                <i aria-hidden="true" class="mdi mdi-calendar-range"></i>
                Filing Frequency:
              </small>
              <small>{{ registration.payment_schedule | titlecase }}</small>
            </p>
          }
          @if (registration.status !== autoRegisterStatuses.REGISTERED) {
            <p class="m-0">
              <small class="text-muted">
                <i aria-hidden="true" class="mdi mdi-calendar-today"></i>
                Last Updated:
              </small>
              <small>{{ registration.updated_at | date:'short' }}</small>
            </p>
          } @else {
            <p class="m-0">
              <small class="text-muted">
                <i aria-hidden="true" class="mdi mdi-calendar-check"></i>
                Date Registered:
              </small>
              <small>{{ registration.updated_at | date:'MMM dd YYYY' }}</small>
            </p>
          }
        </div>
      </div>
      <div class="col-md-3 d-flex align-items-end flex-column">
        <span class="m-3 badge border border-2 user-select-none py-0 text-{{ type }} text-bg-light-{{ type }} border-{{ type }}-subtle">
          {{ registration.status | lowercase | snakeToString }}
        </span>

        @if (registration.status === autoRegisterStatuses.PENDING_PAYMENT) {
          <button (click)="makePayment.emit(registration)"
                  class="mt-auto m-3 btn btn-sm btn-outline-primary align-text-bottom"
                  data-test-id="country-register-payment-button"
                  type="button">
            Make Payment
          </button>
        }
      </div>
    </div>
  </div>
}
